import { InspectorControls } from "@wordpress/block-editor";
import SettingsPanel from "./settings-panel";
import StylesPopup from "./styles-popup";

export default function ShareInspectorControls({
  attributes,
  setAttributes,
  showPopupInEditor,
  setShowPopupInEditor,
}) {
  return (
    <>
      <InspectorControls group="settings">
        <SettingsPanel
          attributes={attributes}
          setAttributes={setAttributes}
          showPopupInEditor={showPopupInEditor}
          setShowPopupInEditor={setShowPopupInEditor}
        />
      </InspectorControls>

      {attributes.displayMode !== "inline" && (
        <InspectorControls group="styles">
          <StylesPopup attributes={attributes} setAttributes={setAttributes} />
        </InspectorControls>
      )}
    </>
  );
}
